import Glide, { Swipe } from '@glidejs/glide/dist/glide.modular.esm'

export default function InitCarouselCards() {
    document.querySelectorAll('.carousel-cards').forEach((root) => {
        const sliderEl = root.querySelector('[data-carousel-cards-slider]')

        if (!sliderEl) {
            return
        }

        // nothing to slide (e.g. collection still empty while editing) — skip
        // mounting glide entirely rather than risk it erroring on 0 slides
        if (!sliderEl.querySelector('.glide__slide')) {
            return
        }

        const listItems = root.querySelectorAll('[data-carousel-cards-list] .carousel-cards__list-item')
        const dots = root.querySelectorAll('[data-carousel-cards-dots] .carousel-cards__dot')
        const prevButton = root.querySelector('[data-carousel-cards-prev]')
        const nextButton = root.querySelector('[data-carousel-cards-next]')

        const getSliderSettings = () => {
            if (window.matchMedia('(max-width: 767px)').matches) {
                return { perView: 3, gap: 12 }
            }

            return { perView: 3, gap: 24 }
        }

        const sliderSettings = getSliderSettings()
        // no loop (client request, applies to every slider on the site) —
        // "slider" + bound:true stops firmly at the last slide instead of
        // "carousel"/rewind wrapping back to the start
        const glide = new Glide(sliderEl, {
            type: 'slider',
            bound: true,
            // glide.js defaults "rewind" to true even for "slider" type —
            // without this it silently wraps around
            rewind: false,
            // 3 equal-width slots always visible (prev/active/next) — the
            // active one is rendered full-size via the ".glide__slide--active"
            // CSS scale/opacity below, not by giving it a bigger slide slot.
            // perView:1 + peek was tried first, but peek only reveals empty
            // slot space around the (much smaller, centered) card — it never
            // reaches the actual neighboring card, so nothing peeked through.
            perView: sliderSettings.perView,
            focusAt: 'center',
            gap: sliderSettings.gap,
            animationDuration: 0,
            // Neos.Neos:ContentCollection wraps the cards in its own
            // ".neos-contentcollection" div — rather than fight that extra
            // wrapper, tell glide to treat it as the slides track directly
            classes: { slides: 'neos-contentcollection' },
        })

        const dotOffset = Math.floor(dots.length / 2)

        function setActive(index) {
            listItems.forEach((item, i) => item.classList.toggle('is-active', i === index))
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === (index + dotOffset) % dots.length))
            // no loop (see the "slider"/bound:true glide config above) —
            // hide whichever arrow can't go any further
            prevButton?.classList.toggle('is-disabled', index === 0)
            nextButton?.classList.toggle('is-disabled', index === listItems.length - 1)
        }

        function goTo(direction) {
            root.classList.remove('is-switching')
            root.offsetWidth
            root.classList.add('is-switching')
            glide.go(direction)
            window.setTimeout(() => root.classList.remove('is-switching'), 820)
        }

        listItems.forEach((item, i) => item.addEventListener('click', () => goTo(`=${i}`)))
        dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(`=${(i - dotOffset + dots.length) % dots.length}`)))

        if (prevButton) {
            prevButton.addEventListener('click', () => goTo('<'))
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => goTo('>'))
        }

        glide.on(['mount.after', 'run'], () => setActive(glide.index))
        glide.mount({ Swipe })

        window.addEventListener('resize', () => {
            const nextSettings = getSliderSettings()
            glide.update({
                perView: nextSettings.perView,
                gap: nextSettings.gap,
            })
        })
    })
}
